import React from 'react';
import PlatformServicePage from './PlatformServicePage';
const TelegramServices: React.FC = () => <PlatformServicePage platform="telegram" />;
export default TelegramServices;
